import React from "react";
import LastSection from "../../assets/ThreeDscan/Last/LastSection.webp";
function Last() {
  return (
    <div className="threeD-last">
      <img src={LastSection} />
      <h2>
        Capture Every Angle,
        <br /> Every Detail with
        <br />
        <span>Precision 3D Scanning</span>
      </h2>
    </div>
  );
}

export default Last;
